import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { cognitoLogin } from '../auth';

import { ENABLE_LOADING } from '../../type/cognito/cognito-login';

export const cognitoLoginByProvider = async (provider) => {
    try {
        await signInWithRedirect({ provider: { custom: provider } });
    } catch (error) {
        if (error.name === "UserAlreadyAuthenticatedException") {
            await signOut();
            await signInWithRedirect({ provider: { custom: provider } });
        } else {
            throw error;
        }
    }
};

export const checkUserLogin = () => {
    return async (dispatch) => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('provider') != null) {
            await cognitoLoginByProvider(urlParams.get('provider'));
        }
        let currentUser;
        try {
            currentUser = await getCurrentUser();
            if (currentUser) {
                dispatch(cognitoLogin());
            } else {
                dispatch({
                    type: ENABLE_LOADING,
                    payload: false,
                });
            }
        } catch (cognitoError) {
            console.error(cognitoError);
        } finally {
            dispatch({
                type: ENABLE_LOADING,
                payload: false,
            });
        }
    };
};
